import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Container,
  Box,
  Grid,
} from "@mui/material";
import Papa from "papaparse";


function shuffle(array) {
  let currentIndex = array.length;

  while (currentIndex != 0) {
    let randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]
    ];
  }

  return array; // <-- return the shuffled array
}


function App() {
  const [greetings, setGreetings] = useState([]);
  const [show, setShow] = useState(false);

  useEffect(() => {
  
  setShow(window.location.pathname.split('/').slice(-1)[0] === 'magnasimarurim');
    fetch('https://docs.google.com/spreadsheets/d/1ZcOQ5VpimXclLgc0KtEVcm_YvzhGsZdmL1xs1zuh2R0/export?format=csv&id=1ZcOQ5VpimXclLgc0KtEVcm_YvzhGsZdmL1xs1zuh2R0')
    .then(res => res.text())
    .then(text => {
      const rows = Papa.parse(text, {
        header: true,
        skipEmptyLines: true,
      }).data.map(d=>Object.values(d));
    

      console.log(shuffle(rows));
      setGreetings(shuffle(rows))
    });
    }, []);
    
  return (
    <Box
    sx={{
      position: "fixed",        // 🔥 background will not move
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundImage: `url("background.jpg")`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      zIndex: -1,
    }}
  >

      <Box
        sx={{
          position: "relative",
          height: "100vh",
          overflowY: "auto",      // 🔥 scrolling happens here
          p: 2,
        }}
      >
<Box
  sx={{
    display: "flex",
    justifyContent: "center",
    width: "100%",
    mb: 4,
  }}
>
  <Typography
    variant="h3"
    sx={{
      pt: 5,
      pb: 5,
      fontWeight: 800,
      color: "white",
      textAlign: "center",
      textShadow: "0px 0px 10px rgba(0,0,0,0.7)",
    }}
  >
    אוהבים וכבר מתגעגעים ❤
  </Typography>
</Box>

      <Container maxWidth="xs">
        <Grid container spacing={3} justifyContent="center" pb={10}>
          {greetings.map((g, idx) => (
            <Grid item xs={12} key={idx}>
              <Card
                sx={{
                  borderRadius: 4,
                  overflow: "hidden",
                  backdropFilter: "blur(6px)",
                  backgroundColor: "rgba(255,255,255,0.5)",
                  boxShadow: 5,
                  width: 300,
                }}
              >
                <CardMedia
                  component="img"
                  image={g[4].split('id=')[1] ? `https://lh3.googleusercontent.com/d/${g[4].split('id=')[1]}=s2048?authuser=0`: 'https://media3.reshet.tv/image/upload/t_grid-item-large/v1676478765/uploads/2023/903431409.webp'}
                  referrerPolicy="no-referrer"
                  height="160"
                  alt={console.log(g[4])}
                />

                <CardContent sx={{ textAlign: "center" }}>
                  <Typography variant="h5" sx={{ fontWeight: 800, mb: 1 }}>
                    {g[2]}
                  </Typography>

                  {show&&<Typography variant="body1" sx={{ fontWeight: 800 }}>
                    {g[3]}
                  </Typography>}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>     
    </Box>

  );
}

export default App;
